import React, { ReactElement } from 'react';
import ContentLoader from 'react-content-loader';
import { SKELETON } from '@utils/const';
type Props = {
  width: string;
  height: string;
};

const ImageSkeleton = ({ width, height }: Props): ReactElement => {
  return (
    <ContentLoader
      speed={SKELETON.speed}
      backgroundColor={SKELETON.backgroundColor}
      width={width}
      height={height}
    >
      <rect x="0" y="0" rx="0" ry="0" width={width} height={height} />
    </ContentLoader>
  );
};

export default ImageSkeleton;
